"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomePageToggleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const HomePageToggleContainer = exports.HomePageToggleContainer = _styledComponents.default.div.withConfig({
  displayName: "HomePageTogglestyles__HomePageToggleContainer",
  componentId: "sc-1j700vi-0"
})(["label{display:flex;margin:0;padding:0;span{font-size:12px;font-weight:600;line-height:18px;}}"]);